"use client";

import { Controller, useWatch } from "react-hook-form";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
} from "@mui/material";

export default function Step2Race({ control, prev, next }) {
  const values = useWatch({
    control,
    defaultValue: {},
  });

  const isNextEnabled =
    values.bloodGroup &&
    values.tshirtSize &&
    values.emergencyContact?.trim() &&
    values.participationCategory;

  return (
    <div
      style={{
        maxWidth: "650px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        gap: "1.5rem",
      }}
      className="shadow rounded-lg bg-white-1"
    >
      <span className="block py-1 text-center text-base rounded-t-lg font-bold bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white-1">
        6th Tour De Sanawar 2025
      </span>

      <div className="w-full h-full p-6 pt-0">
        <div style={{ textAlign: "center" }}>
          <h2
            style={{
              fontSize: "1.875rem",
              fontWeight: "800",
              color: "#1f2937",
            }}
          >
            Race Participant Details
          </h2>
          <p
            style={{
              marginTop: "0.5rem",
              color: "#6b7280",
              fontSize: "0.875rem",
            }}
          >
            Fill in your race-specific details
          </p>
        </div>

        <div
          className="mt-5"
          style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
        >
          {/* Blood Group */}
          <FormControl fullWidth>
            <InputLabel>Blood Group</InputLabel>
            <Controller
              name="bloodGroup"
              control={control}
              render={({ field }) => (
                <Select {...field} label="Blood Group">
                  {["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"].map(
                    (g) => (
                      <MenuItem key={g} value={g}>
                        {g}
                      </MenuItem>
                    )
                  )}
                </Select>
              )}
            />
          </FormControl>

          {/* T-Shirt Size */}
          <FormControl fullWidth>
            <InputLabel>T-Shirt Size</InputLabel>
            <Controller
              name="tshirtSize"
              control={control}
              render={({ field }) => (
                <Select {...field} label="T-Shirt Size">
                  {["XS", "S", "M", "L", "XL", "XXL"].map((s) => (
                    <MenuItem key={s} value={s}>
                      {s}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
          </FormControl>

          {/* Emergency Contact */}
          <Controller
            name="emergencyContact"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Emergency Contact Number"
                placeholder="+91 9876543210"
                fullWidth
                inputProps={{
                  maxLength: 10,
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
                onInput={(e) => {
                  const digits = e.target.value.replace(/\D/g, "").slice(0, 10);
                  if (e.target.value !== digits) {
                    e.target.value = digits;
                    field.onChange(digits);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === " ") e.preventDefault();
                }}
              />
            )}
          />

          {/* Participation Category */}
          <FormControl component="fieldset">
            <FormLabel component="legend">Participation Category</FormLabel>
            <Controller
              name="participationCategory"
              control={control}
              render={({ field }) => (
                <RadioGroup {...field} row>
                  <FormControlLabel
                    value="team"
                    control={<Radio />}
                    label="Representing an Official School Team"
                  />
                  <FormControlLabel
                    value="individual"
                    control={<Radio />}
                    label="Representing as an Individual Participant"
                  />
                </RadioGroup>
              )}
            />
          </FormControl>
        </div>

        {/* Navigation Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 20,
            marginTop: "1.5rem",
          }}
        >
          <Button
            variant="outlined"
            onClick={prev}
            sx={{
              borderColor: "var(--color-blue)",
              color: "var(--color-blue)",
              "&:hover": {
                borderColor: "var(--color-blue-hover)",
                color: "var(--color-blue-hover)",
              },
            }}
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{
              backgroundColor: "var(--color-blue)",
              "&:hover": { backgroundColor: "var(--color-blue-hover)" },
            }}
            onClick={next}
            disabled={!isNextEnabled}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
}
